import { Component } from '@angular/core';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.scss'
})
export class MessagesComponent {
  messages: Array<any> = [];
  saving: boolean = false;
  private originalMessages: Array<any> = [];

  constructor(private readonly messageService: MessageService) { 
    this.messageService.getMessages().subscribe(_ => {
      this.originalMessages = JSON.parse(JSON.stringify(_));
      this.messages = _;
    });
  }

  updateMessage($event: any) {
    this.messages[0].message = $event.target.value;
  }

  cancel() {
    this.messages = JSON.parse(JSON.stringify(this.originalMessages));
  }
  save() {
    this.saving = true;
    this.messageService.saveMessage(this.messages[0].message).subscribe(_ => this.saving = false);
  }

}
